import { Colors, Services } from '@sigma-frontend-libs/commons'
import { EScheduleFrequency } from '@sigmasms/shared-types'

import { components, icons } from '@/utils'

import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'
import encoding from '@/components/services/report-manager/commons/form/encoding'
import filterBy from '@/components/services/report-manager/commons/form/filterBy'
import typeField from '@/components/services/report-manager/commons/form/type'
import readonly from '@/components/services/report-manager/recurrent/form/readonly'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/report-manager/recurrent/utils'
import sticker from '@/components/sticker'

function renderNameField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.name,
        label: this.getTranslate(`${Services['report-manager']}.labels.name`),
        dense: true,
        required: true,
        autofocus: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.name = event
        },
        keypress: event => {
          if (event.keyCode === 13) {
            this.$emit('submit', this.proxy)
          }
        }
      }
    }
  )
}
function renderTypeField(h) {
  return h(
    typeField,
    {
      props: {
        value: this.proxy.type
      },
      on: {
        input: event => {
          this.proxy.type = event
        }
      }
    }
  )
}

function renderFrequencyActivator(h) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.titles.frequency`),
        label: this.frequencyDescription,
        icon: icons.settings,
        color: Colors.grey,
        onClick: () => {
          return null
        },
        width: '100%'
      },
      slot: 'activator'
    }
  )
}
function renderScheduleFrequency(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.scheduleFrequency,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.scheduleFrequency`),
        hint: this.getTranslate(`${serviceNameViaPoint}.hints.scheduleFrequency.${this.proxy.scheduleFrequency}`),
        items: this.frequencies,
        dense: true,
        required: true,
        details: true
      },
      on: {
        input: event => {
          this.proxy.scheduleFrequency = event
        }
      }
    }
  )
}
function renderSpecificWeekDay(h) {
  if (this.proxy.scheduleFrequency === EScheduleFrequency.EVERY_WEEK) {
    return h(
      components.select,
      {
        props: {
          value: this.proxy.specificWeekDay,
          label: this.getTranslate(`${serviceNameViaPoint}.labels.specificWeekDay`),
          hint: this.getTranslate(`${serviceNameViaPoint}.hints.specificWeekDay`),
          items: this.weekDays,
          dense: true,
          clearable: true,
          details: true
        },
        on: {
          input: event => {
            this.proxy.specificWeekDay = event
          }
        }
      }
    )
  }
}
function renderFrequencyInfo(h) {
  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${serviceNameViaPoint}.infos.frequencies`)
      }
    }
  )
}
function renderFrequencyContent(h) {
  return h(
    'div',
    {
      class: `${serviceNameKebabCase}-menu ${serviceNameKebabCase}-menu--gap-12`
    },
    [
      renderScheduleFrequency.call(this, h),
      renderSpecificWeekDay.call(this, h),
      renderFrequencyInfo.call(this, h)
    ]
  )
}
function renderFrequency(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderFrequencyActivator.call(this, h),
      renderFrequencyContent.call(this, h)
    ]
  )
}

function renderFilterByActivator(h) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${Services['report-manager']}.labels.filterBy`),
        label: this.getTranslate(`${Services['report-manager']}.hints.filterBy.${this.filterByHintState}`),
        labelColor: this.filterByLabelColor,
        button: this.filterByActivatorButton,
        icon: icons.filter_list,
        color: Colors.grey,
        onClick: () => {
          return null
        },
        width: '100%'
      },
      slot: 'activator'
    }
  )
}
function renderFilterByContent(h) {
  return h(
    filterBy,
    {
      props: {
        value: this.proxy.filterBy,
        type: this.proxy.type
      },
      on: {
        input: event => {
          this.proxy.filterBy = event
        }
      }
    }
  )
}
function renderFilterBy(h) {
  return h(
    components.menu,
    {
      props: {
        closeOnContentClick: false,
        offsetDistance: 8,
        sameWidth: true,
        rounded: true
      }
    },
    [
      renderFilterByActivator.call(this, h),
      renderFilterByContent.call(this, h)
    ]
  )
}
function renderEncoding(h) {
  return h(
    encoding,
    {
      props: {
        value: this.proxy.csvConfig
      },
      on: {
        input: event => {
          this.proxy.csvConfig = event
        }
      }
    }
  )
}

function renderOwner(h) {
  return h(
    selectorOwner,
    {
      props: {
        value: this.proxy.ownerId,
        dense: true,
        combobox: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}

export default function(h) {
  if (this.isNew) {
    return h(
      components.form,
      {
        class: {
          [`${serviceNameKebabCase}-form`]: true,
          [`${serviceNameKebabCase}-form--new`]: this.isNew
        }
      },
      [
        renderNameField.call(this, h),
        renderTypeField.call(this, h),
        renderFrequency.call(this, h),
        renderFilterBy.call(this, h),
        renderEncoding.call(this, h),
        renderOwner.call(this, h)
      ]
    )
  }

  return h(
    readonly,
    {
      props: {
        value: this.proxy,
        service: Services['report-manager/recurrent']
      }
    }
  )
}
